import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { Field, reduxForm } from 'redux-form';
import { renderCheckboxHtml } from 'src/components/misc/redux-form-helpers';
import { BUSFINDER_UI_URL, SanitizedInnerHTML } from 'src/common';
import costSheet from '../../assets/documents/kostenblatt_v2025_11.pdf';
import tosPDF from '../../assets/documents/tos_v_2.0.pdf';
import shortTosPDF from '../../assets/documents/nutzungsbedingungen_kurzfassung_v2.0.pdf';

class ConfirmDialogUpdateTosForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    render() {
        const { handleSubmit, t } = this.props;

        return (
            <>
                <form className="form-horizontal" onSubmit={handleSubmit}>
                    <p>{t('request_visibility.update_tos.form_info_text')}</p>
                    <SanitizedInnerHTML
                        html={t('request_visibility.update_tos.form_tos_text', {
                            tosPDF: tosPDF,
                            shortTos: shortTosPDF,
                        })}
                    />
                    <br />
                    <SanitizedInnerHTML
                        html={t('request_visibility.update_tos.form_important_notice', {
                            bufLink: BUSFINDER_UI_URL,
                        })}
                    />
                    <br />

                    <div className="row">
                        <div className="col-md-12">
                            <Field
                                name="confirmLiability"
                                component={renderCheckboxHtml}
                                required
                                labelHtml={t('request_visibility.update_tos.confirm_booking_liability', {
                                    busfinderLink: BUSFINDER_UI_URL,
                                })}
                            />
                        </div>
                        <div className="col-md-12">
                            <Field
                                name="confirmCostSheet"
                                component={renderCheckboxHtml}
                                required
                                labelHtml={t('request_visibility.update_tos.confirm_cost_sheet', {
                                    costSheet: costSheet,
                                })}
                            />
                        </div>
                        <div className="col-md-12">
                            <Field
                                name="confirmTos"
                                component={renderCheckboxHtml}
                                required
                                labelHtml={t('request_visibility.update_tos.confirm_tos', {
                                    tosPDF: tosPDF,
                                })}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <span
                            className="btn pull-right"
                            onClick={() => {
                                this.props.handleClose();
                            }}>
                            {' '}
                            {t('request_visibility.update_tos.cancel')}
                        </span>
                        <button type="submit" className="btn btn-primary pull-right">
                            {' '}
                            {t('request_visibility.update_tos.accept')}
                        </button>
                    </div>
                </form>
            </>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    if (!values.confirmTos) {
        errors.confirmTos = 'You must accept the Terms of Service.';
    }

    if (!values.confirmLiability) {
        errors.confirmLiability = 'Required';
    }
    if (!values.confirmCostSheet) {
        errors.confirmCostSheet = 'Required';
    }
    return errors;
};

export default reduxForm({
    form: 'confirmDialogUpdateTosForm',
    validate,
})(ConfirmDialogUpdateTosForm);
